'use client';
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from '@/components/home/HeroSection';
import CredibilityStrip from '@/components/home/CredibilityStrip';
import ServicesOverview from '@/components/home/ServicesOverview';
import WhyChooseUs from '@/components/home/WhyChooseUs';
import GalleryPreview from '@/components/home/GalleryPreview';
import ServiceArea from '@/components/home/ServiceArea';
import Testimonials from '@/components/home/Testimonials';
import FinalCTA from '@/components/home/FinalCTA';
import StickyCTA from '@/components/home/StickyCTA';

export default function HomePage() {
  useEffect(() => {
    const bar = document.createElement('div');
    bar.className = 'scroll-progress';
    bar.style.width = '0%';
    document.body?.appendChild(bar);
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement?.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = `${pct}%`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (bar?.parentNode) bar?.parentNode?.removeChild(bar);
    };
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal:not(.visible)').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 120);
            });
          }
        });
      },
      { threshold: 0.06 }
    );
    document.querySelectorAll('section')?.forEach((s) => obs?.observe(s));
    return () => obs?.disconnect();
  }, []);

  return (
    <div style={{ background: 'var(--mamba-black)', minHeight: '100vh' }}>
      <Header />
      <main>
        <HeroSection />
        <CredibilityStrip />
        <div className="section-divider" />
        <ServicesOverview />
        <div className="section-divider" />
        <WhyChooseUs />
        <div className="section-divider" />
        <GalleryPreview />
        <div className="section-divider" />
        <ServiceArea />
        <div className="section-divider" />
        <Testimonials />
        <div className="section-divider" />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
